import { ChevronRight } from 'lucide-react'
import React from 'react'

export default function StatsComponent2({ heading, Data, centerText, showDropOff = false }) {
    return (
        <>
            <div className='statsOption-new' style={{ marginTop: '30px' }}>

                <div className='tops'>
                    <h5>{heading}</h5>
                    <h4>{centerText}</h4>
                    <h5 style={{ opacity: '0' }}>{heading}</h5>
                </div>

                <div className="cusombox">

                    {
                        Data?.length > 0 ? Data?.map((val, id) => {
                            return (
                                <div key={id} style={{ display: 'flex', alignItems: 'center', gap: id + 1 == Data?.length ? 0 : '5px', width: `calc(100% / ${Data?.length})`,justifyContent:'space-around' }}>
                                    <div className='boxx' style={{ background: val?.color, position: 'relative' }}>
                                        <h5>{val?.value}</h5>
                                        <h6>{val?.name}</h6>
                                        {
                                            showDropOff == true ?
                                                <div style={{position:'absolute',bottom:'-15px',left:'0',right:'0'}}>
                                                    <h5 style={{ padding: '5px', margin: '0 10px', color: 'red', background: "#FFDADA",fontSize:'10px',fontWeight:'400',borderRadius:'4px' }}>
                                                        Drop Off {val?.dropOff ?? ""}
                                                    </h5>
                                                </div>
                                                : ""}
                                    </div>
                                    {
                                        !(id + 1 == Data?.length) ?
                                            <div className='rightarrow'>
                                                <ChevronRight style={{ color: '#0D99FF' }} />
                                            </div>
                                            : ""}
                                </div>
                            )
                        })
                            : ""}
                </div>
            </div>
        </>
    )
}
